export var Name = 'open-product-info-dialog';
export var OpenProductInfoDialogDialog = Name;
export var DialogMode;
(function (DialogMode) {
  DialogMode["Favorites"] = "favorites";
  DialogMode["Loading"] = "loading";
  DialogMode["RewardsShop"] = "rewardsShop";
  DialogMode["StandardBuy"] = "standardBuy";
})(DialogMode || (DialogMode = {}));